<template>
    <div class="block-boy">
        <p class="block-boy__text block-boy__text-one">
            Чем больше подросток занят после учебы, тем меньше у него остается сил и желания искать себя в опасных для здоровья или психики увлечениях. В 14–15 лет еще не надо готовиться к поступлению. Зато можно вовсю пробовать разные профессии или социальные роли на факультативах, в кружках и секциях после школы. А еще менять цвет волос, стрижку, стиль одежды и жизненные принципы.
        </p>
        <BlockParallax
            fixed
            speed="14"
            direction="top"
            transform="translateY"
            class="block-boy__img block-boy__img block-boy__img-one"
        >
            <img
                srcset="../assets/5-img-copy.jpg, ../assets/5-img-copy@2x.jpg 2x"
                src="../assets/5-img-copy.jpg"
            >
        </BlockParallax>

        <BlockParallax
            class="block-boy__img block-boy__img-two"
            fixed
            speed="10"
            offset="250"
            direction="top"
            transform="translateY"
        >
            <img
                srcset="../assets/6-img-copy.jpg, ../assets/6-img-copy@2x.jpg 2x"
                src="../assets/6-img-copy.jpg"
            >
            <div class="image-caption image-caption--pl">Двор проекта Green park</div>
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon-telefono block-boy--icon-desktop" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/ph-3.png"
            >
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon-relampago block-boy--icon-desktop" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/ll-8.png"
            >
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon-zapato block-boy--icon-desktop" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/kk-2.png"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-boy {
        position relative
        margin-top 2.6rem
        display flex
        flex-direction column
        align-items flex-end

        &__text {
            font-size 1.5rem
            line-height 1.47
            color $color-text
            padding-left 5rem
            padding-right 1.8rem
            margin 0
            +layout-sm-and-up() {
                max-width 52rem
                padding 0
            }
            +layout-md-and-up() {
                max-width 36rem
                margin-right 12rem
            }
        }

        &__text-two {
            margin-top 2.1rem
        }

        &__img-one {
            margin 2.5rem -1rem 0 3.1rem
            max-width 38rem
            +layout-xs-and-up() {
                margin-left auto
                margin-right auto
            }
            /*+layout-sm-and-up() {
                position absolute
                left 0
                top 6rem
                margin-top 0
                z-index 1
            }*/
            +layout-md-and-up() {
                position absolute
                left 0
                top -1rem
                margin-top 0
                z-index 1
            }
        }

        &__img-two {
            margin 3rem -1rem 0 -1rem
            +layout-xs-and-up() {
                margin-left 0
                margin-right 0
            }
            +layout-sm-and-up() {
                position relative
                z-index 2
            }
            +layout-md-and-up() {
                margin-top 9rem
            }
        }

        &__icon {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-telefono {
            +layout-md-and-up() {
                top 6rem
                right auto
                left -16rem
                width 9rem
                img {
                    transform rotate(-105deg)
                    width 100%
                }
            }
        }

        &__icon-relampago {
            +layout-md-and-up() {
                top auto
                bottom 11rem
                right -5rem
                width 7rem
                z-index 2
                img {
                    transform rotate(-122deg)
                }
            }
        }

        &__icon-zapato {
            +layout-md-and-up() {
                top 5rem
                right -8rem
                width 9rem
                img {
                    transform rotate(-110deg)
                }
            }
        }
    }
    .image-caption {
        &--pl {
            +layout-md-and-up() {
                padding-left 12rem
            }
        }
    }
</style>
